<template>
  <div :class="componentClass.root" :style="style"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useComponentClass } from '@thomasaull-shared/composables'
import { getHoursAsFloat } from '@/utilities/date'

export interface Props {
  startTime: Date
  endTime: Date
}

const props = defineProps<Props>()

const componentClass = useComponentClass({ props })

const style = computed(() => {
  const left = (100 / 24) * getHoursAsFloat(props.startTime)
  const width = (100 / 24) * getHoursAsFloat(props.endTime) - left

  return {
    left: `${left}%`,
    width: `${width}%`,
  }
})
</script>

<style lang="scss">
.PmDayBackgroundMarkerPure {
  $block: &;

  height: 100%;
  min-height: 200px;
  position: absolute;
  background-color: color.$openingHours;
  opacity: 0.5;
}
</style>
